import React from 'react';
import White_Logo from '../../../assets/images/WhiteLogo.svg';
import SmallMail from '../../Icons/SmallMail.svg';
import SmallPhone from '../../Icons/SmallPhone.svg';
import {
  Contact,
  Content,
  Copyright,
  FooterBottom,
  FooterSection,
  FooterTop,
  LinkColumns,
  LinkItem,
  LinkRow,
  Links,
  ListItem,
  Logo,
  NavSection,
  SubHeadline,
  Subtitle,
} from '../Footer.styles';
import { SocialMediaComponent } from './SocialMediaComponent';

const LearnFooter: React.FC = () => {
  return (
    <FooterSection>
      <FooterTop>
        <Logo>
          <img src={White_Logo} alt="logo" />
        </Logo>
        <Content>
          <div style={{ display: 'flex', alignItems: 'flex-end' }}></div>
          <LinkColumns>
            <nav>
              <NavSection>
                <SubHeadline>Explore</SubHeadline>
                <ul>
                  <li>
                    <ListItem href="https://www.theguarantors.com/renter">
                      Renters
                    </ListItem>
                  </li>
                  <li>
                    <ListItem href="https://www.theguarantors.com/operators">
                      Owners & Operators
                    </ListItem>
                  </li>
                  <li>
                    <ListItem href="https://www.theguarantors.com/brokers">
                      Brokers
                    </ListItem>
                  </li>
                  <li>
                    <ListItem href="https://www.theguarantors.com/faq-renters">
                      FAQ
                    </ListItem>
                  </li>
                  <li>
                    <ListItem href="https://www.theguarantors.com/blog">
                      The Welcome Mat
                    </ListItem>
                  </li>
                </ul>
              </NavSection>
              <NavSection>
                <SubHeadline>Company</SubHeadline>
                <ul>
                  <li>
                    <ListItem href="https://www.theguarantors.com/about">
                      About
                    </ListItem>
                  </li>
                  <li>
                    <ListItem href="https://www.theguarantors.com/contact-us">
                      Contact Us
                    </ListItem>
                  </li>
                  <li>
                    <ListItem href="https://www.theguarantors.com/careers">
                      Careers
                    </ListItem>
                  </li>
                  <li>
                    <ListItem href="https://www.theguarantors.com/press">
                      Press
                    </ListItem>
                  </li>
                  <li>
                    <SocialMediaComponent />
                  </li>
                </ul>
              </NavSection>
            </nav>
          </LinkColumns>
        </Content>
      </FooterTop>
      <FooterBottom>
        <Contact>
          <span>
            <img src={SmallPhone} alt="" height="18px" width="18px" />{' '}
            <a href="tel:+12122660020">(212) 266-0020</a>
          </span>
          <span>
            <img src={SmallMail} alt="" height="18px" width="18px" />{' '}
            <a href="mailto:success@theguarantors.com">
              success@theguarantors.com
            </a>{' '}
          </span>
        </Contact>
        <Subtitle>
          TheGuarantors is a licensed insurance agent and broker. For more
          detailed information, please see our{' '}
          <a
            href="https://www.theguarantors.com/legal-regulatory?hsLang=en"
            style={{ color: 'inherit' }}
          >
            Legal/Regulatory Notice
          </a>
          .
        </Subtitle>
        <LinkRow>
          <Copyright>© 2023 TheGuarantors</Copyright>
          <Links>
            <LinkItem desktopWidth="16%" smallScreenWidth="55%">
              <a
                href="https://www.theguarantors.com/privacy?hsLang=en"
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Privacy Policy
              </a>
            </LinkItem>
            <LinkItem desktopWidth="20%" smallScreenWidth="40%">
              <a
                href="https://www.theguarantors.com/terms?hsLang=en"
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Terms of Service
              </a>
            </LinkItem>
            <LinkItem desktopWidth="30%" smallScreenWidth="55%">
              <a
                href="https://www.theguarantors.com/legal-regulatory?hsLang=en"
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Legal/Regulatory Notice{' '}
              </a>
            </LinkItem>
            <LinkItem desktopWidth="16%" smallScreenWidth="40%">
              <a
                href="https://www.rebny.com/"
                style={{ color: 'inherit', textDecoration: 'none' }}
              >
                Member RBNY
              </a>
            </LinkItem>
          </Links>
        </LinkRow>
        <div style={{ opacity: 0.5 }}>
          <Copyright mobile={true}>© 2023 TheGuarantors</Copyright>
        </div>
      </FooterBottom>
    </FooterSection>
  );
};

export default LearnFooter;
